export default __webpack_public_path__ + "static/logo-black-14eeb3563dff71fc4e8f24c2f2542535.png";